import { render, staticRenderFns } from "./detail_base.vue?vue&type=template&id=85f2cf9a&scoped=true"
import script from "./detail_base.vue?vue&type=script&lang=js"
export * from "./detail_base.vue?vue&type=script&lang=js"
import style0 from "./detail_base.vue?vue&type=style&index=0&id=85f2cf9a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f2cf9a",
  null
  
)

export default component.exports